import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import { LoggingMessageService } from './core/services/logging-message.service';
import { WindowEventsService } from './core/services/windows-events.service';
import { StorageService } from './core/services/storage.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private $subscriptions: Subscription = new Subscription();
  title = 'PerformanceReportsClient';
  availableSubscriptions = new Array<string>();

  private subscription = -1;
  get subscriptionSelected(): number {
    return this.subscription;
  }
  set subscriptionSelected(value: number) {
    this.subscription = value;
  }

  constructor(private router: Router,
              private windowEvents: WindowEventsService,
              private logger: LoggingMessageService,
              private route: ActivatedRoute,
              private sessionService: StorageService) {

    this.subscribeNavigationEvents();
  }

  ngOnInit() {
    this.checkUserSubscriptions();
    this.logger.debug('app.component', 'ngOnInit',  this.subscriptionSelected, this.availableSubscriptions.join(','), 'fired', '');
  }
  
  private postWindowMessage() {
    setTimeout(() => {
      window.parent.postMessage('performancereportsaction:', '*');
    }, 0);
  }
  private subscribeNavigationEvents() {
    // const user = this.user;
    const navigationSubscription = this.windowEvents.navigationChange$
      .subscribe(path => {
        this.handleNavigation(path);
      });
    this.$subscriptions.add(navigationSubscription);
  }

  private checkUserSubscriptions() {
    const subs = this.sessionService.getSubscriptionsAvailable();
    let available = new Array<string>();
    if (subs) {
      available = subs.split(',');
    }
    this.availableSubscriptions = available;    
  }
  
  private handleNavigation(path: string) {
    this.logger.debug('app.component', 'handleNavigation', this.subscriptionSelected, this.availableSubscriptions.join(','), `handleNavigation. path: ${path}`, '');

    let params = {};
    const pathParts = path.split('?');
    if (pathParts.length > 1) {
      path = pathParts[0];
      const queryParts = pathParts[1].split('&');
      queryParts.forEach(qp => {
        const pairParts = qp.split('=');
        params[pairParts[0]] = pairParts[1];
      });
    }

    const navigationExtras = {
      queryParams: params
    };

    this.logger.debug('app.component', 'handleNavigation', this.subscriptionSelected, this.availableSubscriptions.join(','), `handleNavigation. Path:${path}, QueryParams: ${JSON.stringify(params)}`, '');
    this.router.navigate(['performancedashboard'], navigationExtras);
    // this.router.navigateByUrl('performancedashboard');
  }

  unsubscribe() {
    this.logger.info('app.component', 'unsubscribe', this.subscriptionSelected, this.availableSubscriptions.join(','), 'app unsubscribing...', '');
    if (this.$subscriptions) {
        this.$subscriptions.unsubscribe();
    }
  }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
      this.unsubscribe();
  }

}
